import React from "react";
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import Blogs from "./Containers/Blogs/Blogs";
import BlogHome from "./Containers/BlogPost/BlogPost";

const AppRoutes = () => {
  return (
    <Router>
      <Routes>
        <Route exact path="/" element={<Blogs />} />
        <Route exact path="/blog/:title/:issueNumber" element={<BlogHome />} />
      </Routes>
    </Router>
  );
};
export default AppRoutes;
